import { Switch } from "@/components/ui/switch";
import { ColorPicker, Num, Row } from "./shared";

export const LinesTab = ({ d, setPart, opts }) => (
  <div
    className="mt-6 rounded-lg border border-zinc-800 bg-zinc-900 p-5"
    data-testid="drawing-lines"
  >
    <Row label="Print dimension lines">
      <Switch
        data-testid="lines-dimensions"
        checked={!!d.lines.dimensions}
        onCheckedChange={(v) => setPart("lines", { dimensions: v })}
      />
    </Row>
    <Row label="Label edges on the drawing" hint="Shows the profile name">
      <Switch
        data-testid="lines-edge-labels"
        checked={!!d.lines.edge_labels}
        onCheckedChange={(v) => setPart("lines", { edge_labels: v })}
      />
    </Row>
    <Row label="Use abbreviations" hint="SE, HB, OG instead of full names">
      <Switch
        data-testid="lines-show-abbr"
        checked={!!d.lines.show_abbr}
        onCheckedChange={(v) => setPart("lines", { show_abbr: v })}
      />
    </Row>
    {[
      ["dimension_color", "Dimension line color"],
      ["seam_color", "Seam line color"],
      ["wall_color", "Wall line color"],
    ].map(([key, label]) => (
      <Row key={key} label={label}>
        <ColorPicker
          testId={`lines-${key.replace("_", "-")}`}
          value={d.lines[key]}
          options={[...opts.colors, "#71717a"]}
          onChange={(v) => setPart("lines", { [key]: v })}
        />
      </Row>
    ))}
    <Row label="Line weight">
      <Num
        testId="lines-weight"
        value={d.lines.line_weight}
        onChange={(v) => setPart("lines", { line_weight: v })}
      />
    </Row>
  </div>
);
